module.exports = __webpack_public_path__ + "img/stock3.baf8fdca.png";